/**
 * Initialize lazy bacground Image listener
 */
export var initLazyBackgroundImageListener = function (element, setIsVisible) {
    console.log('ini');
    if (window.IntersectionObserver) {
        var lazyBackgroundObserver_1 = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    lazyBackgroundObserver_1.unobserve(element);
                    lazyBackgroundObserver_1.disconnect();
                    setIsVisible(true);
                }
            });
        });
        lazyBackgroundObserver_1.observe(element);
    }
};
export default initLazyBackgroundImageListener;
//# sourceMappingURL=initLazyBackgroundImageListener.js.map